{
  "colorInputLabel": "{label}, {channelLabel}",
  "colorNameAndValue": "{name}: {value}",
  "colorPicker": "색상 피커",
  "twoDimensionalSlider": "2D 슬라이더"
}
